import Marquee from "react-fast-marquee";

const WORDS = ["Compassion", "Precision", "Evidence-Based Care", "Empathy", "Integrity", "Survivorship"];

export const Ribbon = () => (
  <section className="py-8 border-y border-black/5 bg-[#F6F4EE]" data-testid="marquee">
    <Marquee speed={40} gradient={false} pauseOnHover>
      {WORDS.concat(WORDS).map((w, i) => (
        <span key={i} className="marquee-item mx-8 inline-flex items-center gap-8">
          <span className="font-serif-display italic text-3xl sm:text-5xl text-[#1A1C1A]">{w}</span>
          <span className="text-[#B9735A] text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
